var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payment-invoice"},[_c('span',{staticClass:"text-caption"},[_vm._v("Счёт списания")]),_c('span',{staticClass:"text-caption"},[_vm._v("•• "+_vm._s(_vm.paymentInvoice))])])}
var staticRenderFns = []

export { render, staticRenderFns }